const location = { NOT_INITIALIZED: null };

module.exports = location;
